import React, { useState } from "react";
import agentImage from "../../assets/img/rect.png";
import checkIcon from "../../assets/img/check.svg";
import layout from "../../assets/img/find_agent_layout.png";
import knowledgeIcon from "../../assets/img/chat.svg";
import trustworthyIcon from "../../assets/img/trust.svg";
import skilledIcon from "../../assets/img/skills.svg";
import "./FindAgentSection.css";
// import agentVideos from "../../assets/videos/-f70e-446a-890b-7c6c3a930394.mp4";
import axios from "axios";
import selectCorrectUrls from "../../selectCorrectUrls";
import PopupModal from "./PopupModal";
import find_agent from "../../assets/vids/find_agent.mp4";
import emptyCaptions from "../../components/empty-captions.vtt";
import PuffLoader from "react-spinners/PuffLoader";
import { css } from "@emotion/react";

export default function FindAgentSection({ responsiveStatus }) {
  const [backgroundVideo, setBackgroundVideo] = useState(
    // `https://player.vimeo.com/video/702177843?h=f698312f3a&amp;portrait=0&amp;byline=0&amp;title=0&amp;autoplay=1&muted=1&background=1`
    find_agent
  );

  const override = css`
    display: flex;
    margin: auto;
    color: white;
    margin-top: -7px;
  `;

  const [zipCode, setZipCode] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = async () => {
    try {
      setError("");
      setIsLoading(true);

      const response = await axios.get(
        `${
          selectCorrectUrls().quotePortal
        }/uaicins/application/lead/agentdata?zipcode=${zipCode}`
      );

      const data = response.data;

      // Check if AGENT1 is explicitly saying no agents found
      const agent1Name = data?.AGENT1?.agency_name?.trim();
      const noAgentsFound =
        agent1Name === "No Agents Found" ||
        agent1Name === "Please Enter Correct ZipCode" ||
        !agent1Name;

      if (noAgentsFound) {
        setResult([]);
        setError("No agents found for the entered zip code.");
        setIsLoading(false);
      } else {
        const agentsOnly = Object.keys(data)
          .filter((key) => key.startsWith("AGENT") && key !== "original")
          .reduce((obj, key) => {
            obj[key] = data[key];
            return obj;
          }, {});

        setResult(Object.values(agentsOnly));
        setIsLoading(false);
      }

      setShowModal(true);
    } catch (err) {
      setResult(null);
      setError("No data found or an error occurred.");
      setIsLoading(false);
    }
  };

  return (
    // <div style={{ background: '#f9fbff', padding: '60px 20px' }}>
    <>
      <div style={styles.container}>
        <div
          style={{
            maxWidth: "1350px",
            margin: "0 auto",
            display: "flex",
            gap: "40px",
            flexWrap: "wrap",
            padding:
              responsiveStatus === "isDesktop"
                ? "20px"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "20px"
                : "4px",
          }}
        >
          {/* LEFT */}
          <div
            className={
              responsiveStatus === "isDesktop"
                ? "row"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "row"
                : "row-m"
            }
            style={{ width: "100%", marginTop: "40px" }}
          >
            <div className="col-md-6 col-12">
              <div
                style={{
                  flex: "1",
                  minWidth: "300px",
                  paddingLeft:
                    responsiveStatus === "isDesktop"
                      ? "0em"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "0em"
                      : "1em",
                }}
              >
                <p
                  style={{
                    color: "#000000",
                    fontSize:
                      responsiveStatus === "isDesktop"
                        ? "18px"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "18px"
                        : "20px",
                    lineHeight: "1.6",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                  }}
                >
                  <span className="blue-underline">Find an Agen</span>t Near
                  You!
                </p>

                <h3
                  style={{
                    color: "#000",
                    lineHeight: "1.6",
                    fontWeight:
                      responsiveStatus === "isDesktop"
                        ? 500
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? 500
                        : 600,

                    marginTop: "20px",
                    marginBottom: "20px",
                    fontSize:
                      responsiveStatus === "isDesktop"
                        ? "20px"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "20px"
                        : "14px",
                  }}
                >
                  An agent can provide personalized assistance
                </h3>
                <div
                  style={{
                    display: "flex",
                    gap:
                      responsiveStatus === "isDesktop"
                        ? "40px"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "40px"
                        : "0px",
                    flexWrap: "wrap",
                    marginBottom: "30px",
                    flexDirection: "row",
                  }}
                >
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {[
                      "Purchase new policy",
                      "Make payments",
                      "Renew your policy",
                      "View policy coverages & ID card",
                    ].map((item, i) => (
                      <li
                        key={i}
                        style={{
                          marginBottom: "12px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={checkIcon}
                          alt="check"
                          style={{ width: "20px", marginRight: "10px" }}
                        />
                        <span className="textStyle">{item}</span>
                      </li>
                    ))}
                  </ul>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {[
                      "Get claims status information",
                      "Upload claim related photos",
                      "Report a claim online",
                      "and much more",
                    ].map((item, i) => (
                      <li
                        key={i}
                        style={{
                          marginBottom: "12px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={checkIcon}
                          alt="check"
                          style={{ width: "20px", marginRight: "10px" }}
                        />
                        <span className="textStyle">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* ZIP SEARCH */}
                <div
                  style={{
                    background: "#eef5fc",
                    padding:
                      responsiveStatus === "isDesktop"
                        ? "20px"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "20px"
                        : "10px 6px",

                    borderRadius: "10px",
                    maxWidth: "500px",
                    border: "1px solid #E5E3E3",
                  }}
                >
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "#000",
                    }}
                  >
                    Find an agent
                  </label>
                  <div className="agentBox">
                    <input
                      value={zipCode}
                      onChange={(e) => {
                        // Only allow numeric characters, limit to 5 digits
                        const sanitized = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 5);
                        setZipCode(sanitized);
                      }}
                      onPaste={(e) => {
                        e.preventDefault(); // Prevent default paste
                        const pasted = e.clipboardData.getData("text");
                        const digitsOnly = pasted
                          .replace(/\D/g, "")
                          .slice(0, 5);
                        if (digitsOnly) {
                          setZipCode((prev) => (prev + digitsOnly).slice(0, 5));
                        }
                      }}
                      type="text"
                      placeholder="Enter zip code"
                      maxLength={5}
                      onKeyDown={(e) => {
                        const isDigit = /^[0-9]$/.test(e.key);
                        const allowedControlKeys = [
                          "Backspace",
                          "Tab",
                          "ArrowLeft",
                          "ArrowRight",
                          "Delete",
                        ];
                        const isControlCombo = e.ctrlKey || e.metaKey;

                        if (
                          !isDigit &&
                          !allowedControlKeys.includes(e.key) &&
                          !isControlCombo
                        ) {
                          e.preventDefault();
                        }

                        // Only trigger search if Enter is pressed and ZIP code is 5 digits
                        if (
                          e.key === "Enter" &&
                          zipCode.length === 5 &&
                          !showModal
                        ) {
                          handleSearch();
                        }
                      }}
                      style={{
                        flex: 1,
                        padding: "10px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        marginRight: "8px",
                        outline: "none",
                      }}
                    />

                    <button
                      onClick={handleSearch}
                      disabled={showModal}
                      style={{
                        background: "#0E72D6",
                        color: "#fff",
                        border: "none",
                        padding: "8px 20px",
                        // marginLeft: "8px",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                    >
                      {isLoading ? (
                        <div>
                          <PuffLoader
                            color={"white"}
                            css={override}
                            size={30}
                          />
                        </div>
                      ) : (
                        "Search"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div
                className={`${
                  responsiveStatus === "isDesktop"
                    ? "curve-Image"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "curve-Image"
                    : "curve-Image-m"
                }`}
              >
                <div
                  style={{
                    transform: `${
                      responsiveStatus === "isDesktop"
                        ? "translateX(0%)"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "translateX(0%)"
                        : "translateX(0%)"
                    }`,
                    marginTop: "20px",
                    marginLeft:
                      responsiveStatus === "isDesktop"
                        ? "19%"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "8%"
                        : "19%",
                  }}
                >
                  <div
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "iframe-cover"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "iframe-cover"
                        : "iframe-cover-m"
                    }`}
                  >
                    {/* <iframe
                    src={backgroundVideo}
                    frameBorder="0"
                    allow="autoplay; fullscreen"
                    allowFullScreen
                    title="Background Video"
                    style={{
                      objectFit: "contain",
                      zIndex: 1,
                      transform: "scaleY(1.8)",
                      transformOrigin: "center center",
                      overflow: "hidden",
                    }}
                  ></iframe> */}
                    <video
                      src={backgroundVideo}
                      autoPlay
                      loop
                      muted
                      playsInline
                      style={{
                        objectFit: "contain",
                        zIndex: 1,
                        transform: "scaleY(1.8)",
                        transformOrigin: "center center",
                        overflow: "hidden",
                      }}
                    >
                      <track
                        kind="captions"
                        src={emptyCaptions}
                        srcLang="en"
                        label="English"
                      />
                    </video>
                  </div>
                </div>

                {/* Floating Labels */}

                <div
                  className={`${
                    responsiveStatus === "isDesktop"
                      ? "floatingBox1"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "floatingBox1"
                      : "floatingBox1-m"
                  }`}
                >
                  <FloatingLabel
                    icon={knowledgeIcon}
                    text={"Extensive\nknowledge"}
                    top="10%"
                    left="3%"
                  />
                </div>
                <div
                  className={`${
                    responsiveStatus === "isDesktop"
                      ? "floatingBox2"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "floatingBox2"
                      : "floatingBox2-m"
                  }`}
                >
                  <FloatingLabel
                    icon={trustworthyIcon}
                    text="Trustworthy"
                    top="20%"
                    left="15%"
                  />
                </div>
                <div
                  className={`${
                    responsiveStatus === "isDesktop"
                      ? "floatingBox3"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "floatingBox3"
                      : "floatingBox3-m"
                  }`}
                >
                  <FloatingLabel
                    icon={skilledIcon}
                    text={"Skilled\nProfessionals"}
                    top="30%"
                    left="15%"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT */}
        </div>
      </div>
      {showModal && (
        <PopupModal
          show={showModal}
          onClose={() => setShowModal(false)}
          cards={error ? [] : result}
          zipCode={zipCode}
          error={error} // optional: pass error into modal if needed
        />
      )}
    </>
  );
}

// UPDATED FloatingLabel STYLE
const FloatingLabel = ({ icon, text, top, left }) => (
  <div
    style={{
      //   position: 'absolute',
      top,
      left,
      transform: "translateX(0%)",
      background: "#fff",
      border: "1px solid #007bff",
      borderTopRightRadius: "30px",
      borderBottomLeftRadius: "30px",
      //   borderBottomRightRadius: '30px',
      padding: "6px 32px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
      whiteSpace: "pre-line",
    }}
  >
    <div
      style={{
        backgroundColor: "#e6f0ff",
        borderRadius: "50%",
        padding: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "32px",
        height: "32px",
      }}
    >
      <img src={icon} alt="icon" style={{ width: "37px", height: "37px" }} />
    </div>
    <span className="floatingBoxText">{text}</span>
  </div>
);
const FloatingDiv = ({ icon, text, top, left }) => (
  <div
    style={{
      position: "absolute",
      top,
      left,
      transform: "translateX(-50%)",
      background: "#fff",
      border: "1px solid #007bff",
      borderTopRightRadius: "30px",
      borderBottomLeftRadius: "30px",
      //   borderBottomRightRadius: '30px',
      padding: "8px 14px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
      whiteSpace: "pre-line",
    }}
  >
    <div
      style={{
        backgroundColor: "#e6f0ff",
        borderRadius: "50%",
        padding: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "32px",
        height: "32px",
      }}
    >
      <img src={icon} alt="icon" style={{ width: "16px", height: "16px" }} />
    </div>
    <span className="floatingBoxText">{text}</span>
  </div>
);
const styles = {
  container: {
    width: "100%",
    minHeight: "400px",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "right",
  },
};
